// Catalogue prices exclude GST.
export const GST_NOTE = "Exclusive of GST";

// Nbyula's Website Pixel. The GTM container loads a second pixel, so name this one.
export const WEBSITE_PIXEL_ID = "4844506905597450";

// Marketplace service slug for each checkout selection, per exam.
const EXAM_PREP_PRODUCTS = Object.freeze([
  Object.freeze({ exam: "dmat", selection: "advanced", slug: "dmat-advanced" }),
  Object.freeze({
    exam: "dmat",
    selection: "mock:sprint-one",
    slug: "dmat-sprint-one",
  }),
  Object.freeze({
    exam: "dmat",
    selection: "mock:sprint-two",
    slug: "dmat-sprint-two",
  }),
  Object.freeze({
    exam: "dmat",
    selection: "mock:bundle",
    slug: "dmat-bundle",
  }),
  Object.freeze({
    exam: "gmat",
    selection: "advanced:month",
    slug: "gmat-advanced",
  }),
  Object.freeze({
    exam: "gmat",
    selection: "advanced:year",
    slug: "gmat-advanced-yearly",
  }),
  ...[3, 4, 5, 6].map((number) =>
    Object.freeze({
      exam: "gmat",
      selection: `mock:mock-${number}`,
      slug: `gmat-mock-${number}`,
    })
  ),
  Object.freeze({
    exam: "gmat",
    selection: "mock:all",
    slug: "gmat-mocks-all",
  }),
  Object.freeze({
    exam: "sat",
    selection: "advanced:month",
    slug: "sat-advanced",
  }),
  Object.freeze({
    exam: "sat",
    selection: "advanced:year",
    slug: "sat-advanced-yearly",
  }),
  ...[3, 4, 5, 6].map((number) =>
    Object.freeze({
      exam: "sat",
      selection: `mock:mock-${number}`,
      slug: `sat-mock-${number}`,
    })
  ),
  Object.freeze({
    exam: "sat",
    selection: "mock:all",
    slug: "sat-mocks-all",
  }),
]);

export function examPrepProductMap(exam) {
  return Object.freeze(
    Object.fromEntries(
      EXAM_PREP_PRODUCTS.filter((product) => product.exam === exam).map(
        (product) => [product.selection, product.slug]
      )
    )
  );
}

// Subscription states a learner can still cancel from the account page.
export const CANCELLABLE_SUBSCRIPTION_STATUSES = Object.freeze([
  "active",
  "pending",
  "halted",
  "paused",
]);

// CDN icon size (px) -> fixed Tailwind size class (TW2 has no arbitrary values).
export const ICON_SIZE_CLASSES = Object.freeze({
  12: "w-3 h-3",
  13: "w-3.5 h-3.5",
  14: "w-3.5 h-3.5",
  15: "w-4 h-4",
  16: "w-4 h-4",
  17: "w-4 h-4",
  18: "w-5 h-5",
  19: "w-5 h-5",
  20: "w-5 h-5",
  21: "w-5 h-5",
  22: "w-6 h-6",
  23: "w-6 h-6",
  24: "w-6 h-6",
  25: "w-6 h-6",
  26: "w-7 h-7",
  28: "w-7 h-7",
  32: "w-8 h-8",
  34: "w-9 h-9",
  40: "w-10 h-10",
  55: "w-14 h-14",
});

// India Standard Time is UTC+5:30, with no daylight saving.
export const IST_OFFSET_MS = 5.5 * 3600000;

export const CALCULATOR_KEYS = Object.freeze([
  "MC",
  "MR",
  "MS",
  "M+",
  "⌫",
  "CE",
  "C",
  "√",
  "7",
  "8",
  "9",
  "÷",
  "4",
  "5",
  "6",
  "\u00d7",
  "1",
  "2",
  "3",
  "−",
  "0",
  ".",
  "=",
  "+",
  "±",
  "1/x",
  "%",
]);
